import React from 'react';
import './Badge.css';

export type BadgeVariant =
  | 'active'
  | 'onhold'
  | 'completed'
  | 'archived'
  | 'inprogress'
  | 'open'
  | 'critical'
  | 'high'
  | 'medium'
  | 'low'
  | 'none'
  | 'brand'
  | 'neutral';

export type BadgeSize = 'sm' | 'md';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  size = 'md',
  children,
  className = '',
  ...props
}) => {
  const sizeClass = size === 'sm' ? 'ui-badge-sm' : '';
  const variantClass = `ui-badge-${variant}`;
  const combinedClassName = ['ui-badge', variantClass, sizeClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={combinedClassName} {...props}>
      {children}
    </span>
  );
};

export default Badge;
